export default "__VITE_ASSET__5668a2b9__"